import React, { useState } from 'react';
import './MeetingTable.css';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
interface Column {
    name: string;
    key: string;
}

interface DynamicTableProps {
    columns: Column[];
    data: Record<string, any>[];
    showCheckbox?: boolean; // NEW
    onSelect?: (record: any) => void; // NEW
}

const MeetingTable: React.FC<DynamicTableProps> = ({
    columns,
    data,
    showCheckbox = false,
    onSelect
}) => {
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

    const handleSelect = (row: any, index: number) => {
        setSelectedIndex(index);
        onSelect?.(row); // pass to parent
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="customer-meeting-container">
                <table
                    className="table table-bordered"
                    style={{ width: '100%' }}
                >
                    <thead>
                        <tr>
                            {showCheckbox && <th style={{ width: '4%' }}></th>}{' '}
                            {/* empty header */}
                            {columns.map((col) => (
                                <th key={col.key}>{col.name}</th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {data.map((row, idx) => (
                            <tr key={idx}>
                                {showCheckbox && (
                                    <td className="p-0 d-flex justify-content-center align-items-center">
                                        <input
                                            type="radio"
                                            checked={selectedIndex === idx}
                                            onChange={() =>
                                                handleSelect(row, idx)
                                            }
                                        />
                                    </td>
                                )}

                                {columns.map((col) => (
                                    <td key={col.key}>
                                        {row[col.key] ?? '--'}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </LocalizationProvider>
    );
};

export default MeetingTable;
